import { mutatorAction } from 'satcheljs';
import { connectedAccountsStore } from '../../store/store';
export var updateAdvancedOutgoingPort = mutatorAction('updateAdvancedOutgoingPort', function (outgoingPort) {
    var store = connectedAccountsStore();
    store.connectAdvancedState.outgoingPort = outgoingPort;
});
//# sourceMappingURL=updateAdvancedOutgoingPort.js.map